import { Injectable, TemplateRef } from '@angular/core';
import { Absence } from '@wilson/interfaces';

export interface AbsenceCellViewPreviewContext {
  absence: Absence;
  isMinimalMode: boolean;
  isSelected: boolean;
  cardTitle: string;
  isLowOpacity: boolean;
  testId: string;
  heightClass: string;
}

export interface DeferredAbsenceCellViewCardMultipleAssignmentsContext {
  isLowOpacity: boolean;
  heightClass: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeferredAbsenceCellViewCardHelperService {
  private previewTemplate: TemplateRef<AbsenceCellViewPreviewContext> | null =
    null;
  private multipleAssignmentsTemplate: TemplateRef<DeferredAbsenceCellViewCardMultipleAssignmentsContext> | null =
    null;

  setMultipleAssignmentsTemplate(
    template: TemplateRef<DeferredAbsenceCellViewCardMultipleAssignmentsContext>,
  ): void {
    this.multipleAssignmentsTemplate = template;
  }

  getMultipleAssignmentsTemplate(): TemplateRef<DeferredAbsenceCellViewCardMultipleAssignmentsContext> | null {
    return this.multipleAssignmentsTemplate;
  }

  setPreviewTemplate(
    template: TemplateRef<AbsenceCellViewPreviewContext>,
  ): void {
    this.previewTemplate = template;
  }

  getPreviewTemplate(): TemplateRef<AbsenceCellViewPreviewContext> | null {
    return this.previewTemplate;
  }

  clearReferences(): void {
    this.previewTemplate = null;
    this.multipleAssignmentsTemplate = null;
  }
}
